module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// ./~/i18next-xhr-backend/index.js
// module id = 123
// module chunks = 35783957827783 114276838955818